import type { Category, SubCategory } from "@scott/ui-d2c/types";
import type React from "react";
import { BannerNav } from "./banner-nav";
import { CategoryTitle } from "./category-title";
import { useNavigationStore } from "./use-navigation-store";

// Navigation hierarchy constants
const NAV_LEVEL_THIRD = 3;

interface ThirdPanelProps {
  isActive: boolean;
  data: Category | null;
  onPanelChange: (panel: string, data: SubCategory) => void;
}

const ThirdPanel: React.FC<ThirdPanelProps> = ({
  isActive,
  data,
  onPanelChange,
}) => {
  const { setLevel, clearFromLevel, pushToDataLayer } = useNavigationStore();

  return (
    <div
      className={`fixed top-0 right-0 bottom-0 left-0 z-30 w-full overflow-hidden border-nav-gray bg-nav-bg-secondary pt-6 pl-6 font-nav-paragraph font-nav-weight text-nav-color transition-transform duration-300 ease-in-out lg:z-20 lg:w-[372px] ${isActive ? "translate-x-16 lg:translate-x-[420px]" : "-translate-x-full"}`}
      id="third"
    >
      {data && (
        <>
          <div className="h-[88px]" />
          <CategoryTitle
            link={data.link}
            linkClicked={() => {
              clearFromLevel(NAV_LEVEL_THIRD);
              pushToDataLayer();
            }}
            linkName={data.linkName}
            title={data.title}
            titleEN={data.titleEN}
          />
          <div className="mr-6 border-nav-gray border-b" />
          <div className="linkscontainer relative max-h-[calc(100vh-224px)] overflow-auto pr-6">
            <ul className="py-3 text-xl">
              {data.children?.map((subCategory, index) => (
                <li
                  className="m-0 cursor-pointer py-2 text-[16px]"
                  key={`third-subcategory-${subCategory.titleEN || index}`}
                >
                  {subCategory.children ? (
                    <span
                      className={`block hover:text-nav-hover ${subCategory.onSale ? "text-sale hover:text-salehover" : ""}`}
                      onClick={() => {
                        setLevel(NAV_LEVEL_THIRD, subCategory.titleEN, index);
                        onPanelChange("fourth", subCategory);
                      }}
                    >
                      {subCategory.title || subCategory.titleEN}
                    </span>
                  ) : (
                    <a
                      className={`block font-normal hover:text-nav-hover ${subCategory.onSale ? "text-sale hover:text-salehover" : ""}`}
                      href={subCategory.link}
                      onClick={() => {
                        setLevel(NAV_LEVEL_THIRD, subCategory.titleEN, index);
                        pushToDataLayer();
                      }}
                    >
                      {subCategory.title || subCategory.titleEN}
                    </a>
                  )}
                </li>
              ))}
            </ul>
            <BannerNav
              banners={data.entries || []}
              currentLevel={NAV_LEVEL_THIRD}
            />
          </div>
        </>
      )}
    </div>
  );
};

export { ThirdPanel };
